import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=136c75bc&scoped=true"
import script from "./Simple.vue?vue&type=script&lang=js"
export * from "./Simple.vue?vue&type=script&lang=js"
import style0 from "./Simple.vue?vue&type=style&index=0&id=136c75bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c75bc",
  null
  
)

export default component.exports